import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import type React from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";

import { topHeaderHeightPx } from "@/components/NewDesign/newDesignUtils";
import { ampli } from "@/config";
import { zinc } from "./colors";
import { FeedPanelContext } from "./FeedPanelContext";

export default function PanelHeader({ children }: { children: React.ReactNode }) {
  const { closePanel } = useContext(FeedPanelContext);
  const { feedId } = useParams();

  return (
    <Box
      sx={{
        bgcolor: zinc[800],
        px: 2,
        height: topHeaderHeightPx,
        display: "flex",
        alignItems: "center",
        borderRadius: 1.5,
        border: `1px solid ${zinc[400]}`,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      {closePanel && (
        <IconButton
          onClick={() => {
            ampli.exitFeed({ feedId });
            closePanel();
          }}
          size="small"
          sx={{
            color: zinc[400],
            "&:hover": { color: "white", bgcolor: zinc[700] },
            ml: 1,
          }}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </Box>
  );
}
